/* eslint-disable @next/next/no-img-element */

/**
 * Brand assets. These are served as static files from `public/brand/` and
 * rendered via <img>, NOT inlined into the DOM — both source SVGs (exported
 * from Illustrator) share generic class names (`.st0`…) and gradient ids, so
 * inlining them together would cause style/gradient collisions. Rendering them
 * as external images keeps each in its own isolated document.
 */

/**
 * The oStudent leaf mark (transparent background, ~1.23:1). Sized by height so
 * the aspect ratio is preserved; pair with the "oStudent" wordmark for a lockup.
 */
export function Logo({
  height = 28,
  className = "",
}: {
  height?: number;
  className?: string;
}) {
  return (
    <img
      src="/brand/ostudent-logo.svg"
      alt="oStudent"
      style={{ height }}
      className={`w-auto select-none ${className}`}
      draggable={false}
    />
  );
}

/**
 * The square app-icon tile (baked-in gradient background + rounded corners).
 * Used as the login badge and anywhere a compact brand tile reads better than
 * the bare mark.
 */
export function AppIcon({
  size = 56,
  className = "",
}: {
  size?: number;
  className?: string;
}) {
  return (
    <img
      src="/brand/ostudent-app-icon.svg"
      alt="oStudent"
      width={size}
      height={size}
      className={`select-none ${className}`}
      draggable={false}
    />
  );
}

/**
 * Mark + wordmark lockup (used in the top bar and desktop sidebar header).
 */
export function LogoWordmark({
  height = 26,
  className = "",
}: {
  height?: number;
  className?: string;
}) {
  return (
    <span className={`flex items-center gap-2 ${className}`}>
      <Logo height={height} />
      <span className="text-xl font-bold tracking-tight text-fg">oStudent</span>
    </span>
  );
}
